import ButtonBase from '@mui/material/ButtonBase'
import { styled } from '@mui/material/styles'

interface StatusPillButtonProps {
  bg: string
  borderColor: string
  textColor: string
}

// Reusable pill-style button shared by the top-bar status pill and the banner
// row's DETAILS toggle, so both read from the same styling. Colours are passed
// in (per severity); shouldForwardProp keeps those custom props off the DOM.
const StatusPillButton = styled(ButtonBase, {
  shouldForwardProp: prop =>
    !['bg', 'borderColor', 'textColor'].includes(prop as string)
})<StatusPillButtonProps>(({ bg, borderColor, textColor }) => ({
  height: '2rem',
  borderRadius: '14px',
  padding: '0 10px',
  gap: '6px',
  backgroundColor: bg,
  border: `1px solid ${borderColor}`,
  color: textColor,
  fontWeight: 500,
  fontSize: 11.5,
  alignSelf: 'center',
  '&:hover': { filter: 'brightness(0.97)' }
}))

export default StatusPillButton
